import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

import Slides from '@ifeng-fe/ui_pc_slides';

import { formatImage } from '@ifeng-fe/public_method';

class HomeAd extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const sliderTmpl = function sliderTmpl(item) {
            return (
                <div>
                    <a className={styles.blockA} href={item.url} target="_blank" title={item.desc}>
                        <img
                            src={item.image ? formatImage(item.image, 1000, 90) : ''}
                            style={{ width: '100%', height: 90 }}
                        />
                    </a>
                </div>
            );
        };

        const sliderConfig = {
            arrows: false,
            autoplay: true,
            dots: false,
            dotsAction: 'hover',
            direction: 'forward',
            pauseOnHover: true,
            autoplayInterval: 5000,
            axis: 'horizonta',
            initialSlide: 0,
            unitSize: 1000,
            speed: 500,
            infinite: true,
            sliderTmpl,
        };

        return content.show ? (
            <div className={styles.homeAd}>
                <Slides content={content.data} config={sliderConfig} />
            </div>
        ) : (
            <div />
        );
    }
}

const HomeAdChip = props => {
    return (
        <Chip id="170133" type="struct" title="美食盛典-首页通栏广告" groupName="正文-首页" content={props.content}>
            <HomeAd />
        </Chip>
    );
};

HomeAdChip.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(HomeAdChip);
